/**
 * @name responsive
 * @description Responsive in ngx-responsive
 *
 * @license MIT
 */
import { Provider } from '@angular/core';
import { ResponsiveDirective } from './responsive';
export const RESPONSIVE_DIRECTIVE: Provider[] = [ ResponsiveDirective ];
export * from './responsive';
